import {
  collectionGroup,
  doc,
  getDoc,
  query,
  where,
  getDocs,
  collection,
  setDoc,
  deleteDoc,
} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { db } from "../firebase-config";
import Nav from "../components/navbar";
import parse from "html-react-parser";
import moment from "moment";
import {
  AiFillLinkedin,
  AiFillInstagram,
  AiFillTwitterSquare,
} from "react-icons/ai";
import { FaGithubSquare } from "react-icons/fa";
import { MdWork } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import empty from "../assets/empty.json";
import Lottie from "lottie-react";
import Toptitle from "../components/pagetop";
import { BsFillBookmarkFill, BsBookmark } from "react-icons/bs";
import { UserAuth } from "../context/authContext";
import MiniOther from "../components/minOther";

export default function Others() {
  const { state } = useLocation();

  const { userID } = state;

  const { user } = UserAuth();

  const [posts, setPosts] = useState([]);
  const [userInfo, setUserInfo] = useState({});

  const [users, setUsers] = useState([]);

  const getPosts = async () => {
    const GrpColRef = query(
      collectionGroup(db, "Posts"),
      where("publishedBy", "==", userID)
    );

    const querySnapshot = await getDocs(GrpColRef);

    let tempPosts = [];

    querySnapshot.forEach((post) => {
      tempPosts.push({
        id: post.id,
        data: post.data(),
      });
    });

    setPosts(tempPosts);
  };

  useEffect(() => {
    getPosts();
  }, [userID]);

  const getUser = async () => {
    const docRef = doc(db, "users", userID);

    let temp = {};
    await getDoc(docRef).then((snap) => {
      temp = { ...snap.data() };
    });
    setUserInfo(temp);
  };

  useEffect(() => {
    getUser();
  }, [userID]);

  const getUsers = async () => {
    const colRef = collection(db, "users");

    const querySnapshot = await getDocs(colRef);

    let tempUsers = [];

    querySnapshot.forEach((post) => {
      tempUsers.push({
        id: post.id,
        data: post.data(),
      });
    });

    setUsers(tempUsers);
  };

  useEffect(() => {
    getUsers();
  }, []);

  let navigator = useNavigate();

  const profChange = (name, userID) => {
    const replaced = name.replace(" ", "");
    const nav = `/profile/@${replaced}`;
    navigator(nav, { state: { userID: userID } });
  };

  return (
    <div className="mainWrapper">
      <Nav />
      <div className="innerwrapper overflow-y-auto p-0  bgAccount">
        <Toptitle title={userInfo.username} bg="transparent" />

        <div
          className={
            posts.length > 0
              ? "mt-2 h-[32rem] px-7 w-full flex flex-row gap-7 "
              : "mt-2 h-[32rem] px-7 w-full flex flex-row justify-between items-center gap-7 "
          }
        >
          <div className="h-full w-[63%] flex flex-col gap-3 overflow-y-auto">
            {posts.length > 0 ? (
              posts.map((pst, index) => (
                <MiniOther
                  postid={pst.id}
                  ind={index}
                  title={pst.data.title}
                  tumbnail={pst.data.tumbnailURL}
                  publishedby={pst.data.publishedBy}
                  name={userInfo.username}
                  category={pst.data.category}
                  profpic={userInfo.profilePic}
                  content={pst.data.content}
                  datepub={pst.data.datePublished}
                />
              ))
            ) : (
              <motion.div
                className=" pb-10 relative w-full h-full flex flex-col items-center justify-center font-semibold text-zinc-500"
                animate={{ opacity: 1 }}
                initial={{ opacity: 0 }}
                transition={{
                  ease: "easeIn",
                  duration: 0.5,
                  delay: 0.3,
                }}
                exit={{ opacity: 0 }}
              >
                <Lottie
                  animationData={empty}
                  loop={true}
                  style={{ width: "55%" }}
                />
                <div className=" absolute left-1/2 -translate-x-1/2 bottom-[7.5rem] text-zinc-500 font-semibold">
                  There aren't any publications to display yet!
                </div>
              </motion.div>
            )}
          </div>
          <div className="h-full w-[37%] flex flex-col">
            {userInfo && (
              <div className="w-full h-full flex flex-col justify-between">
                <div className="h-28 w-80 pl-3 bg-[#141414] flex flex-row self-end justify-start items-center rounded-l-full rounded-2xl ">
                  <div className="w-24 h-24  rounded-full overflow-hidden">
                    <img
                      src={userInfo.profilePic}
                      referrerPolicy="no-referrer"
                      alt="profile pic"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="h-full flex flex-col justify-center">
                    <div className=" text-lg font-semibold text-zinc-100 capitalize ml-3 flex flex-row items-center">
                      {userInfo.username}
                    </div>
                    {userInfo.occupation ? (
                      <div className=" text-zinc-500 ml-3 font-medium mt-2 flex flex-row items-center">
                        <MdWork size={20} className="fill-OrangyRed mr-3" />
                        {userInfo.occupation}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <motion.div
                  className="bg-[#141414] w-full h-[17rem]  rounded-2xl flex flex-col justify-between overflow-hidden"
                  animate={{ opacity: 1, scale: 1 }}
                  initial={{ opacity: 0, scale: 0.8 }}
                  transition={{ ease: "easeOut", duration: 0.4, delay: 0.8 }}
                >
                  {userInfo.bio ? (
                    <div className="w-full h-[77%] flex flex-col p-7">
                      <div className="text-zinc-500 font-semibold">About:</div>
                      <div className="mt-2 text-zinc-200 ">{userInfo.bio}</div>
                    </div>
                  ) : (
                    <div className="w-full h-[77%] flex flex-col justify-center items-center p-7 text-zinc-500 font-semibold">
                      No available bio!
                    </div>
                  )}
                  <div className="w-full h-[25%] bg-[#121212] rounded-t-full relative flex flex-row items-center justify-around">
                    <div className="py-2 px-4 bg-[#161616] absolute -top-6 text-sm text-zinc-500 rounded-xl font-semibold left-1/2 transform -translate-x-1/2">
                      Social Links
                    </div>
                    {!userInfo.instaURL &&
                    !userInfo.twitterURL &&
                    !userInfo.githubURL &&
                    !userInfo.linkedin ? (
                      <div className="w-full h-full flex items-center justify-center text-zinc-500 font-semibold">
                        No available social links!
                      </div>
                    ) : (
                      <div className="w-full h-full flex flex-row items-center justify-around">
                        {userInfo.instaURL && (
                          <a
                            href={userInfo.instaURL}
                            target="_blank"
                            rel="noreferrer"
                            className="transition ease-in-out hover:scale-110"
                          >
                            <AiFillInstagram
                              size={30}
                              className="fill-OrangyRed"
                            />
                          </a>
                        )}
                        {userInfo.twitterURL && (
                          <a
                            href={userInfo.twitterURL}
                            target="_blank"
                            rel="noreferrer"
                            className="transition ease-in-out hover:scale-110"
                          >
                            <AiFillTwitterSquare
                              size={30}
                              className="fill-OrangyRed"
                            />
                          </a>
                        )}
                        {userInfo.githubURL && (
                          <a
                            href={userInfo.githubURL}
                            rel="noreferrer"
                            target="_blank"
                            className="transition ease-in-out hover:scale-110"
                          >
                            <FaGithubSquare
                              size={27}
                              className="fill-OrangyRed"
                            />
                          </a>
                        )}
                        {userInfo.linkedin && (
                          <a
                            href={userInfo.linkedin}
                            rel="noreferrer"
                            target="_blank"
                            className="transition ease-in-out hover:scale-110"
                          >
                            <AiFillLinkedin
                              size={30}
                              className="fill-OrangyRed"
                            />
                          </a>
                        )}
                      </div>
                    )}
                  </div>
                </motion.div>
                <motion.div className="w-full h-[6.7rem] bg-[#141414] rounded-2xl flex flex-col px-6 py-2 justify-between">
                  <div className="text-zinc-500 font-semibold">
                    Suggested people
                  </div>
                  <div className="w-full flex flex-row gap-3">
                    {users.length > 0 ? (
                      users.map(
                        (use, index) =>
                          use.id !== user.uid &&
                          index % 2 !== 0 &&
                          use.id !== "modal" &&
                          use.id !== userInfo.uid && (
                            <div
                              key={index}
                              className="h-[3.7rem] w-[3.7rem] rounded-full overflow-hidden"
                              onClick={() =>
                                profChange(use.data.username, use.id)
                              }
                            >
                              <img
                                src={use.data.profilePic}
                                className="w-full h-full object-cover"
                              />
                            </div>
                          )
                      )
                    ) : (
                      <div>dfv</div>
                    )}
                  </div>
                </motion.div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
